import { useEffect, useState } from 'react';
import { FieldValues, Path, UseFormResetField } from 'react-hook-form';

export const useResetOnChange = <T extends FieldValues>(
  targetField: unknown,
  dependantFieldNames: Path<T>[],
  resetField: UseFormResetField<T>
) => {
  const [previousTargetFieldValue, setPreviousTargetFieldValue] = useState<unknown>();

  useEffect(() => {
    if (targetField === previousTargetFieldValue) {
      return;
    }
    dependantFieldNames.forEach((fieldName) => resetField(fieldName, undefined));
    setPreviousTargetFieldValue(targetField);
  }, [previousTargetFieldValue, dependantFieldNames, resetField, targetField]);
};
